import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormUtil } from 'src/app/utils/formutils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { EditResourcesModalService } from '../../../common/modals/edit-resources-modal.service';
import { EditResourcesModalComponent } from '../../../common/modals/edit-resources-modal.component';
import { ResourceSearchPipe } from '../../../common/resources.pipes';

@Component({
    selector: 'app-resources-library',
    imports: [
        CommonModule,
        FormsModule,
        ResourceSearchPipe
    ],
    templateUrl: './resources-library.component.html',
    styleUrls: ['./resources-library.component.css']
})
export class ResourcesLibraryComponent implements OnInit {
  global_resources: any = [];
  practice_resources: any = [];
  global_resources_list: any = [];

  addResourceForm: UntypedFormGroup;
  formUtil: FormUtil;
  fileForm: FormData = new FormData();
  public modalRef: BsModalRef;
  search = "";
  current_library = {
    name: "Practice Library",
    bucket: this.practice_resources,
  };

  @ViewChild("resourceInput") resourceInput: ElementRef;

  constructor(
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private editResourcesModalService: EditResourcesModalService,
    private modalService: BsModalService,
  ) {
    this.addResourceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      file: [null, []],
      // category: [
      //     null,
      //     []
      // ],
      file_type: [null, [Validators.required]],
      url: [null, []],
    });
  }

  ngOnInit(): void {
    // Retrieve the resources for ACCOUNTANT or CLIENT
    this.dashboardService.get_resources().then((res: any) => {
      const response = res;
      this.global_resources = response.global_resources;
      this.practice_resources = response.practice_resources;

      this.current_library.bucket = this.practice_resources;

      this.editResourcesModalService.delete.subscribe((sub) => {
        console.log("deleted resource", sub);

        this.practice_resources = this.practice_resources.filter((resource) => {
          return resource.id != sub;
        });

        this.current_library.bucket = this.practice_resources;
      });
    });
  }

  openResourceModal(resource, is_new): void {
    this.modalRef = this.modalService.show(EditResourcesModalComponent, {
      class: "modal-lg",
    });
    this.modalRef.content.ngOnChanges({ resource: resource, is_new: is_new });

    const subscription = this.modalService.onHide.subscribe(
      (reason: string) => {
        if (
          this.editResourcesModalService.resource !== null &&
          this.editResourcesModalService.resource !== undefined
        ) {
          if (!is_new) {
            for (let x = 0; x < this.current_library.bucket.length; x++) {
              if (
                this.current_library.bucket[x].id ===
                this.editResourcesModalService.resource.id
              ) {
                this.current_library.bucket[x] =
                  this.editResourcesModalService.resource;
                break;
              }
            }
          } else {
            this.current_library.bucket.unshift(
              this.editResourcesModalService.resource
            );
          }
        }

        this.editResourcesModalService.resource = null;
        this.editResourcesModalService.is_new = null;
        subscription.unsubscribe();
      }
    );
  }

  change_library(type): void {
    if (type === "global") {
      this.current_library.bucket = this.global_resources;
      this.current_library.name = "Global Library";
    } else if (type === "practice") {
      this.current_library.bucket = this.practice_resources;
      this.current_library.name = "Practice Library";
    }
  }
}
